/**
 * monthChart — helpers for ECharts charts whose category axis is months.
 *
 * On phones (`vertical`) the axes are swapped so months run down the
 * y axis, one row each, earliest at the top. Long ranges then grow the
 * chart taller instead of squeezing bars and rotating labels.
 */

const ROW_HEIGHT = 28;
const CHROME_HEIGHT = 90; /* legend + value-axis labels + padding */

/**
 * Returns `{ xAxis, yAxis }` for the given orientation. `categoryAxis`
 * and `valueAxis` are written as for the desktop (columns) layout.
 */
export function monthAxes(vertical, categoryAxis, valueAxis) {
  if (!vertical) return { xAxis: categoryAxis, yAxis: valueAxis };
  const { rotate, ...categoryLabel } = categoryAxis.axisLabel || {};
  return {
    xAxis: {
      ...valueAxis,
      splitNumber: 3,
      axisLabel: { ...valueAxis.axisLabel, hideOverlap: true },
    },
    yAxis: {
      ...categoryAxis,
      inverse: true,
      axisLabel: categoryLabel,
    },
  };
}

/** Chart height: `columnsHeight` on desktop, one row per month on phones. */
export function monthChartHeight(vertical, months, columnsHeight) {
  if (!vertical) return columnsHeight;
  return Math.max(240, months * ROW_HEIGHT + CHROME_HEIGHT);
}

/** Rounded bar ends that face away from the value axis origin. */
export function barRadius(vertical) {
  return vertical ? [0, 4, 4, 0] : [4, 4, 0, 0];
}

/** Compact ₺ value labels for the narrow value axis. */
export const compactTry = (v) =>
  Math.abs(v) >= 1000 ? `₺${Math.round(v / 1000)}k` : `₺${Math.round(v)}`;
